var lib_core         = require("lib-core");
var cio_ui_templates = require("ui-templates");

var EditorHolderInterface = require("./../editorHolderInterface.js");

var TabView          = require("./tabView.js");
var TabModel         = require("./tabModel.js");
var MasterController = require("./../master/masterController.js");

var TabController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
    this.heavyHandler = new lib_core.HeavyHandler();
    this.heavyHandler.setOrder(['update_model', 'update_view', 'rebuild_view']);
};
lib_core.inherit(TabController, lib_core.Controller);

TabController.inject = {masterController: MasterController};

// Add Interfaces
// var TabInterface = new function () {};
// _.extend(TabInterface, TabController.prototype);
lib_core.extend(TabController, EditorHolderInterface); // Tab can hold editor
// TabController.prototype = TabInterface;

module.exports = TabController;

TabController.prototype.beforeLoad = function() {
    this.data = this.parent.data;

    var buttonElements = null;
    if (this.configuration.button) buttonElements = this.configuration.button;

    var theme = null;
    if(this.configuration.theme) theme = this.configuration.theme;

    this.getModel().button = this.masterController.addTab(this, buttonElements, theme);

    if(this.configuration.expanded_toolbar) this.getModel().expanded_toolbar = this.configuration.expanded_toolbar;

    lib_core.Controller.prototype.beforeLoad.call(this);
};

TabController.prototype.afterLoad = function () {
    this.autoAppendArgs = [this.name(), null, this.name(), null, null];
    lib_core.Controller.prototype.afterLoad.call(this);
};

TabController.prototype.createView = function () {
    var parentView = this.masterController.getView();
    return new TabView(this.getModel(), parentView, this.rootStateMachine, this.configuration);
};

TabController.prototype.createModel = function () {
    return new TabModel();
};

/**
 * Initializes the heavyHandler and connects it to the afterHandle of the SM
 */
TabController.prototype.initHeavyHandler = function () {
    var self = this;
    this.getStatemachine().stateCollection.forEach(function (stateName, state) {
        state.outTransitions.forEach(function (transition) {
            transition.addActionAfter(function () {
                self.heavyHandler.runAllHeavies();
            });
        });
        state.eventActions.forEach(function (transition) {
            transition.addActionAfter(function () {
                self.heavyHandler.runAllHeavies();
            });
        });
    });

    var mergeState = this.autoAppendArgs[0] ? this.autoAppendArgs[0] : "idle";
    this.parent().getStatemachine().getStateObj(mergeState).inTransitions.forEach(function (transition) {
        transition.addActionAfter(function () {
            self.heavyHandler.runAllHeavies();
        });
    });

    //also run heavies on stopRec
    this.root.onFinishAction(this, function () {
        if(self.getModel().active())
            self.heavyHandler.runAllHeavies();
    });
};

TabController.prototype.afterBuild = function () {
    this.initHeavyHandler();
};
